import { useLocation } from "react-router-dom";
import { useDataStore } from "../store/dataStore";

export default function AppBackground() {
  const location = useLocation();
  const isMobile = useDataStore((s) => s.isMobile);

  const isDashboard = location.pathname === "/dashboard";

  return (
    <div
      className="app-bg"
      style={{
        backgroundImage: isMobile ? 'url("/bg2.svg")' : 'url("/bg.svg")',
        opacity: isDashboard ? 0.4 : 1,
      }}
    />
  );
}
